export const splitUnitCategory = (title: string) => {
	const titleArray = title.split(" ");

	return titleArray;
};
